"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/hooks/auth";

const SignupButton = () => {
  const { user } = useAuth();
  const pathname = usePathname();

  // Don't show sign up button if user is signed in
  if (user) {
    return null;
  }

  // Determine if we're on a designers/profiles page
  const isDesignersPage =
    pathname.includes("/designers") ||
    pathname.includes("/join") ||
    pathname.includes("/profiles") ||
    pathname.includes("/portfolios");

  // Show "Submit Application" button on designers pages
  if (isDesignersPage) {
    return (
      <Link
        href="/join"
        className="inline-flex h-10 items-center justify-center rounded-full bg-[#2B1B1C] px-5 text-sm font-medium text-white hover:bg-[#3a2327] transition-colors whitespace-nowrap"
      >
        Apply
      </Link>
    );
  }
};

export default SignupButton;
